import AjaxUtils from "../../util/ajax_utils";
import DataObject from "../../data/data-object";

export const ScanObject = class {

    constructor(cmp, data) {
        this.cmp = cmp;
        if(data) {
            this.data = data;
            if(this.data.get('_id')) {
                this.id = this.data.get('_id');
            }
            if(this.data.get('latest_result_set')) {
                this.latest_result_set = this.data.get('latest_result_set');
            }
        }
    }

    load() {

    }

    scan_control(action, callback) {
        const self = this;

        let url;
        if (this.cmp.$globalFlags.spa) {
            url = `/scan/control/${action}/${this.id}`; }
        else {
            url = `/scans/${this.id}`;
            if (this.latest_result_set) {
                url += `/instance/${this.latest_result_set}`;
            }
        }

        if (this.cmp.$globalFlags.spa) {
            return AjaxUtils.ajax_get({
                url: url,
                success: function (data) {
                    if (data && callback) {
                        callback(data);
                    } else if (!data) {
                        self.cmp.$flash({
                            type: 'error',
                            message: 'There was no response data received from the server'
                        });
                    }
                },
                opts: {no_response_message: 'There was a server error when attempting the scan action'}
            });
        } else {
            return AjaxUtils.ajax_post({
                url: url,
                data: {'action': action},
                success: function (json, status, xhr) {
                    const msg = (() => {
                        switch (action) {
                            case 'start':
                                return 'Scan started';
                            case 'pause':
                                return 'Scan paused';
                            case 'resume':
                                return 'Scan resumed';
                            case 'resume-window':
                                return 'Scan window control resumed';
                            case 'abort':
                                return 'Scan aborted';
                            case 'rescan':
                                return 'Re-running scan';
                            case 'delete':
                                return 'Scan deleted';
                        }
                    })();
                    self.cmp.$flash({
                        type: 'success',
                        message: msg
                    });
                    if (callback) {
                        callback(json);
                    }
                },
                fail: function (json, status, xhr) {
                    const message = json?.error ? json.error :
                        json?.message ? json.message :
                        "There was no response data received from the server";

                    self.cmp.$flash({
                        type: 'error',
                        message: message,
                    });
                },
                opts: {
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    no_response_message: 'There was a server error when attempting the scan action'
                }
            });
        }
    }

    startScan(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('start', callback);
        }
    }

    rescanScan(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('rescan', callback);
        }
    }

    pauseScan(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('pause', callback);
        }
    }

    resumeScan(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('resume', callback);
        }
    }

    abortScan(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('abort', callback);
        }
    }

    delete(callback) {
        var _id = this.id;
        if(_id) {
            return this.scan_control('delete', callback);
        }
    }
}


export const ApckScanTable = {
    props: {
        src: {
            type: String,
            default: '/scans'
        },
        polling: {
            type: Boolean,
            default: true
        },
        showFilters: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        const cmp = this;
        const userId = cmp.$permissions?.impersonated;
        const actions = [{
                title: "View Scan",
                icon: "fa-eye",
                class: "btn-primary",
                handler: (rec) => this.viewScan(rec, true),
            },{
                title: "Start Scan",
                icon: "fa-play",
                class: "btn-positive",
                handler: this.start,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (status === "NONE"
                        && (row.get('permissions')?.can_run
                        || row.get('user_summary')?._id === userId));
                }
            },{
                title: "Rescan",
                icon: "fa-refresh",
                class: "btn-primary",
                handler: this.rescan,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (!["RUNNING", "PENDING", "QUEUED", "PAUSED"].includes(status)
                    && status !== "NONE"
                    && (row.get('permissions')?.can_run
                    || row.get('user_summary')?._id === userId));
                }
            },{
                title: "Pause",
                icon: "fa-pause",
                class: "btn-warning",
                handler: this.pause,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (["RUNNING", "PENDING"].includes(status)
                    && status !== "PAUSED"
                    && (row.get('permissions')?.can_pause
                    || row.get('user_summary')?._id === userId));
                }
            },{
                title: "Resume",
                icon: "fa-play",
                class: "btn-positive",
                handler: this.resume,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (status === "PAUSED"
                        && (row.get('permissions')?.can_run
                        || row.get('user_summary')?._id === userId));
                }
            },{
                title: "Abort",
                icon: "fa-ban",
                class: "btn-negative",
                handler: this.abort,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (["RUNNING", "PENDING", "QUEUED", "PAUSED"].includes(status)
                        && (row.get('permissions')?.can_abort
                        || row.get('user_summary')?._id === userId));
                }
            },{
                title: "Cancel Schedule",
                icon: "fa-calendar-times",
                class: "btn-warning",
                handler: this.cancelSchedule,
                conditions: function(row) {
                    var nextScan = row.get('next_scan');
                    // Only show if scan has a scheduled next scan time (epoch int)
                    return nextScan && nextScan !== "Never"
                        && (row.get('permissions')?.can_edit
                        || row.get('user_summary')?._id === userId);
                }
            },{
                title: "Edit Settings",
                icon: "fa-pencil",
                class: "btn-secondary",
                handler: this.settings,
                conditions: function(row) {
                    return row.get('permissions')?.can_edit || row.get('user_summary')?._id === userId;
                }
            },{
                title: "Delete Scan",
                icon: "fa-trash",
                class: "btn-negative",
                handler: this.delete,
                conditions: function(row) {
                    var status = row.get('raw_status');
                    return (["COMPLETED", "NONE", "ABORTED", "FAILED"].includes(status)
                        && (row.get('permissions')?.can_delete
                        || row.get('user_summary')?._id === userId));
                }
            }];

        return {
            statusFilters: [
                {label: 'All Scans', value: 'all'},
                {label: 'Scheduled Scans', value: 'scheduled'},
                {label: 'Unscheduled Scans', value: 'unscheduled'},
                {label: 'Running Scans', value: 'running'},
                {label: 'Queued Scans', value: 'queued'},
                {label: 'Completed Scans', value: 'completed'},
                {label: 'Aborted Scans', value: 'aborted'},
                {label: 'Paused Scans', value: 'paused'},
            ],
            activeStatusFilter: 'all',
            actions: actions,
            store: null,
            pollId: null,
            bulkActionsOpen: false
        };
    },
    computed: {
        cols() {
            return [
                {"ctype": "limitedtextcolumn", "width": "45%", "minWidth": 400, "data": "description", "heading": "Scan name", "canSearch": true, "direction": "desc"},
                ...((this.$permissions?.superadmin_group && this.$supportUi?.visible) ? [{"ctype": "scanwarningscolumn", "width": 90, "canSearch": false, "data": "warning_count", "heading": "Warnings"}] : []),
                {"ctype": "vulncolumnnew", "width": 210, "canSearch": false, "data": "vuln_counts", "heading": "Vulnerabilities"},
                {"width": 70, "center": true, "canSearch": false, "data": "result_set_count", "heading": "Scans"},
                {"ctype": "datecolumnnew", "width": 110, "canSearch": true, "data": "next_scan", "heading": "Next run"},
                {"ctype": "usercolumn", "width": 180, "canSearch": true, "data": "user_summary", "heading": "Started by"},
                {"ctype": "scanprogresscolumnnew", "width": 220, "canSearch": false, "data": (row) => row, "heading": "Status"},
                {"ctype": "datecolumn", "width": 140, "canSearch": true, "hidden": true, "data": "scan_complete", "heading": "Completed"},
                {"ctype": "column", "width": 165, "canSearch": true, "hidden": true, "data": "scan_hub", "heading": "Scan hub"},
            ];
        },
    },
    methods: {
        getScanLink(rec) {
            if (rec instanceof DataObject) {
                rec = rec.raw;
            }
            const _id = rec['_id'];
            const latest_rs = rec['latest_result_set'];

            if (!this.$globalFlags.spa) {
                return `/scans/${_id}`;
            }

            let res = {
                name: 'scans.results',
                params: {
                    scan_id: _id
                }
            };
            if(latest_rs) {
                res = {
                    name: 'scans.results.instance',
                    params: {
                        scan_id: _id,
                        result_id: latest_rs
                    }
                };
            }
            return res;
        },
        viewScan(rec, newTab=false) {
            const link = this.getScanLink(rec);
            if (this.$globalFlags.spa) {
                this.$router.push(link);
            } else {
                if (newTab) {
                    window.open(link, '_blank');
                } else {
                    window.location.href = link;
                }
            }
        },
        scansReport: function() {
            let url = this.store.url;
            const lastParams = this.store.lastParams;
            let params = {};
            if (lastParams) {
                 Object.entries(lastParams).forEach(([key, value]) => {
                     if (value !== null && value !== undefined) {
                         params[key] = value;
                     }
                 });
                const headings = this.$refs.scantable.loadColumnPickerData()
                    .filter(col => !col.hidden)
                    .map(col => col.heading)
                    .join(',');
                if (headings) {
                    params.headings = headings;
                }
            }

            const [baseUrl, queryString] = url.split('?');
            if (baseUrl === "/scans/mine") {
                params.onlyMyScans = 1;
            } else if (baseUrl.match("^/scans/fromvuln/")) {
                const vulnId = baseUrl.substr(baseUrl.lastIndexOf("/") + 1);
                params.vulnId = vulnId;
            }

            const reportUrl = "/scans/csv";
            window.requestVulnerabilityReport(reportUrl, JSON.stringify(params), null, "application/json");
        },
        start: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to start this scan?',
                title: 'Start scan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.startScan(function () {
                        cmp.store.reload();
                    });
                },
            });
        },
        rescan: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to restart this scan?',
                title: 'Rescan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.rescanScan(function (json) {
                        if (json.redirect) {
                            window.location.replace(json.redirect);
                        } else {
                            cmp.store.reload();
                        }
                    });
                },
            });
        },
        pause: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to pause this scan?',
                title: 'Pause scan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.pauseScan(function () {
                        cmp.store.reload();
                    });
                },
            });
        },
        resume: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to resume this scan?',
                title: 'Resume scan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.resumeScan(function () {
                        cmp.store.reload();
                    });
                },
            });
        },
        abort: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to abort this scan?',
                title: 'Abort scan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.abortScan(function () {
                        cmp.store.reload();
                    });
                },
            });
        },
        delete: function(row) {
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to delete this scan?',
                title: 'Delete scan',
                onConfirm: function () {
                    const scan = new ScanObject(cmp, row);
                    scan.delete(function () {
                        cmp.store.reload();
                    });
                },
            });
        },
        cancelSchedule: function(row) {
            const cmp = this;
            const scanName = row.get('description');
            this.$modal.confirm({
                message: 'Are you sure you want to cancel the schedule for "' + scanName + '"?\n\n' +
                    'Note: Cancelling the schedule will not stop any currently running scan, ' +
                    'but will prevent future scheduled runs.',
                title: 'Cancel schedule',
                onConfirm: function () {
                    const scanId = row.get('_id');
                    const url = '/scans/' + scanId + '/cancel_schedule';

                    AjaxUtils.ajax_post({
                        url: url,
                        success: function (json, status, xhr) {
                            if (json && json.success) {
                                cmp.$flash({
                                    type: 'success',
                                    message: json.message || 'Schedule cancelled successfully'
                                });
                                // Refresh the table to update the display
                                cmp.$refs.scantable.store.reload();
                            } else {
                                cmp.$flash({
                                    type: 'error',
                                    message: json && json.message ? json.message : 'Failed to cancel schedule'
                                });
                            }
                            cmp.store.reload();
                        },
                        fail: function (xhr, status, error) {
                            const message = xhr.responseJSON && xhr.responseJSON.message
                                ? xhr.responseJSON.message
                                : 'An error occurred whilst cancelling the schedule';
                            cmp.$flash({
                                type: 'error',
                                message: message
                            });
                            cmp.store.reload();
                        }
                    });
                },
            });
        },
        settings: function(row) {
            const rowId = row.data._id
            if (!this.$globalFlags.spa) {
                if (row['latest_result_set']) {
                    window.open(`/scans/${rowId}/instances/${row['latest_result_set']}/settings`, '_blank');
                } else {
                    window.open(`/scans/${rowId}/settings`, '_blank');
                }
                return;
            }

            if(row['latest_result_set']) {
                this.$router.push({
                    name: 'scans.results.instance',
                    params: {
                        scan_id: rowId,
                        result_id: row['latest_result_set']
                    },
                    query: {
                        tab: 'Settings'
                    }
                });
            } else {
                this.$router.push({
                    name: 'scans.results',
                    params: {
                        scan_id: rowId
                    },
                    query: {
                        tab: 'Settings'
                    }
                });
            }
        },
        bulkResume: function() {
            this.bulkActionsOpen = false;
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to resume all scans?',
                title: 'Resume all scans',
                onConfirm: function () {
                    AjaxUtils.ajax_post({
                        url: `${cmp.src}/control`,
                        data: JSON.stringify({action: 'resume'}),
                        success: function (json, status, xhr) {
                            if (json) {
                                cmp.$flash({message: 'Resumed all scans'})
                                cmp.$refs.scantable.store.reload();
                            }
                        },
                        fail: function () {
                        },
                    });
                },
            });
        },
        bulkPause: function() {
            this.bulkActionsOpen = false;
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to pause all scans?',
                title: 'Pause all scans',
                onConfirm: function () {
                    AjaxUtils.ajax_post({
                        url: `${cmp.src}/control`,
                        data: JSON.stringify({action: 'pause'}),
                        success: function (json, status, xhr) {
                            if (json) {
                                cmp.$flash({message: 'Paused all scans'})
                                cmp.$refs.scantable.store.reload();
                            }
                        },
                        fail: function () {},
                    });
                },
            });
        },
        bulkAbort: function() {
            this.bulkActionsOpen = false;
            const cmp = this;
            this.$modal.confirm({
                message: 'Are you sure you want to abort all scans?',
                title: 'Abort all scans',
                onConfirm: function () {
                    AjaxUtils.ajax_post({
                        url: `${cmp.src}/control`,
                        data:JSON.stringify({action: 'abort'}),
                        success: function (json, status, xhr) {
                            if (json) {
                                cmp.$flash({message: 'Aborted all scans'})
                                cmp.$refs.scantable.store.reload();
                            }
                        },
                        fail: function () {},
                    });
                },
            });
        },
        setStatusFilter: function (status) {
            this.activeStatusFilter = status;
            const params = {
                offset: this.store.start,
                page_size: this.store.limit,
                page: this.store.getPage(),
                dir: this.store.dir,
                sort: this.store.sort,
                status_filter: status,
            };
            this.store.load(params);
        }
    },
    mounted: function() {
        var store = this.$refs.scantable.$data.store;
        if (store) {
            this.store = store;
        }
        // start polling
        if (this.polling) {
            this.pollId = setInterval(() => {
                this.store.reload(true);
            }, 10000);
        }
    },
    destroyed: function () {
        if (this.polling) {
            clearInterval(this.pollId);
        }
    },
    template: `
        <apck-table
            ref="scantable"
            tableId="all-scans-table"
            :showColumnPicker="true"
            :new-style-table="true"
            :columns="cols"
            :src="src"
            :sglRowAction="viewScan"
            :middleRowAction="(rec) => viewScan(rec,  true)"
            :ctrlRowAction="(rec) => viewScan(rec,  true)"
            :actions="actions"
            :limit="40"
            class="new-ui"
        >
            <template v-slot:tbarBtnGroup v-if="showFilters">
                <ui-dropdown-select
                    :modelValue="activeStatusFilter"
                    :options="statusFilters"
                    iconLeft="fa-filter"
                    iconRight=""
                    @update:modelValue="setStatusFilter"
                />

                <ui-dropdown-base
                    label="Bulk Actions"
                    iconLeft="fa-sparkles"
                    iconRight=""
                    :open="bulkActionsOpen"
                    @update:open="bulkActionsOpen = $event"
                >
                    <ui-layout direction="column" gap="0" align="stretch">
                        <ui-button
                            label="Resume All"
                            iconLeft="fa-play"
                            type="ghost"
                            @click="bulkResume"
                        />

                        <ui-button
                            label="Pause all"
                            iconLeft="fa-pause"
                            type="ghost"
                            @click="bulkPause"
                        />

                        <ui-button
                            label="Abort all"
                            iconLeft="fa-cancel"
                            type="ghost"
                            color="red"
                            @click="bulkAbort"
                        />
                    </ui-layout>
                </ui-dropdown-base>
            </template>
        </apck-table>
    `
}
